import { render, staticRenderFns } from "./Mailbox.vue?vue&type=template&id=6ddd8004&scoped=true"
import script from "./Mailbox.vue?vue&type=script&lang=js"
export * from "./Mailbox.vue?vue&type=script&lang=js"
import style0 from "./Mailbox.vue?vue&type=style&index=0&id=6ddd8004&prod&scoped=true&lang=css"
import style1 from "./Mailbox.vue?vue&type=style&index=1&id=6ddd8004&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddd8004",
  null
  
)

export default component.exports